"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacebookSquare = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var FacebookSquare = function FacebookSquare() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M24 2.667v18.666A2.667 2.667 0 0121.333 24h-5a.667.667 0 01-.666-.667v-8h3.12c.317 0 .59-.223.653-.533l.48-2.4a.333.333 0 00-.32-.4h-3.933V7.667c0-.184.149-.334.333-.334h3.333A.667.667 0 0020 6.667v-2A.667.667 0 0019.333 4H16a4 4 0 00-4 4v4h-1.64a.667.667 0 00-.667.667v2c0 .368.299.666.667.666H12v8a.667.667 0 01-.667.667H2.667A2.667 2.667 0 010 21.333V2.667A2.667 2.667 0 012.667 0h18.666A2.667 2.667 0 0124 2.667z"
  });
};

exports.FacebookSquare = FacebookSquare;